__turbopack_context__.v({
  "billboard": "AcfBillboard-module-scss-module__-JZQXa__billboard",
  "billboard-background": "AcfBillboard-module-scss-module__-JZQXa__billboard-background",
  "billboard-container": "AcfBillboard-module-scss-module__-JZQXa__billboard-container",
  "billboard-mobile-image": "AcfBillboard-module-scss-module__-JZQXa__billboard-mobile-image",
});
